import styled from "styled-components";

export const HeaderMenuIconDefaultBox = styled.img`
    max-height: 25px;
    padding: 0 1rem;
`;